<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card :title="`Localization (${workingLocalization.language.name})`">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          :label-placeholder="`Product Name (${workingLocalization.language.name})`"
          v-model="workingLocalization.product_name"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          :label-placeholder="`Trademarked Name (${workingLocalization.language.name})`"
          v-model="workingLocalization.product_name_tm"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          :label-placeholder="`Latin Name (${workingLocalization.language.name})`"
          v-model="workingLocalization.latin_name"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-textarea
          :label="`Description (${workingLocalization.language.name})`"
          v-model="workingLocalization.description"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row">
      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2" @click="saveChanges"><vs-button class="mx-1 w-full">Save Changes</vs-button></div>
      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full" color="warning" type="border" @click="revert">Cancel</vs-button></div>
    </div>
  </vx-card>
</template>

<script>
  import types from '@/models';
  import { productHelpers } from '@/models/helpers';
  import api from '@/http/api';

  export default {
    data() {
      return {
        loading: false,
        helpers: productHelpers,
        originalLocalization: new types.Localization(),
        workingLocalization: new types.Localization(),
      }
    },
    props: {
      localization: {
        type: types.Localization,
        required: true,
      },
    },
    watch: {
      localization: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.originalLocalization = JSON.parse(JSON.stringify(newVal));
        this.workingLocalization = JSON.parse(JSON.stringify(newVal));
      },
      isModified: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        this.$emit('unsavedChangesUpdate', newVal);
      }
    },
    computed: {
      isModified() {
        return JSON.stringify(this.originalLocalization) !== JSON.stringify(this.workingLocalization);
      },
    },
    methods: {
      revert() {
        this.workingLocalization = JSON.parse(JSON.stringify(this.originalLocalization));
      },
      async saveChanges() {
        if (!this.isModified) return;
        this.loading = true;

        const success = await api.saveProductLocalization(this.workingLocalization);

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `Changes successfully saved` : `Error saving changes`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});

        this.originalLocalization = JSON.parse(JSON.stringify(this.workingLocalization));

        this.revert();

        this.$emit('productChanged');

        this.loading = false;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
